import { FullContainer } from '@gorila-shared-ui/components';
import { Tab, Tabs } from 'baseui/tabs-motion';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import {
  INTEGRATIONS_SECTION,
  LIVE_STATUS_SECTION,
  NOTIFICATIONS_SECTION,
  SUB_ACCOUNT_SECTION,
  USERS_SECTION,
} from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { settingsSectionsState } from '../../storage/app';
import IntegrationsTab from '../settings/integrations/IntegrationsTab';
import { LiveStatusSettingsTab } from '../settings/liveStatus/LiveStatusSettingsTab';
import { NotificationSettingsTab } from '../settings/notifications/NotificationSettingsTab';
import { SubAccountTab } from '../settings/subAccounts/SubAccountTab';
import { UsersTab } from '../settings/users/UsersTab';

export function SettingsPage() {
  const {
    overrides: { tabOverflowOverrides, tabOverrides, tabsOverrides },
  } = useStyles();
  const sections = useRecoilValue(settingsSectionsState);
  const [activeKey, setActiveKey] = useState<string>(sections[0]);

  if (!sections.length) return null;

  return (
    <FullContainer verticalFlex>
      <Tabs
        activeKey={activeKey}
        onChange={({ activeKey }) => {
          setActiveKey(activeKey as string);
        }}
        activateOnFocus
        overrides={tabsOverrides}
      >
        {sections.includes(SUB_ACCOUNT_SECTION) && (
          <Tab
            title="Subcuentas"
            overrides={tabOverrides}
            key={SUB_ACCOUNT_SECTION}
          >
            <SubAccountTab />
          </Tab>
        )}
        {sections.includes(USERS_SECTION) && (
          <Tab
            title="Usuarios"
            overrides={tabOverrides}
            key={USERS_SECTION}
          >
            <UsersTab />
          </Tab>
        )}
        {sections.includes(INTEGRATIONS_SECTION) && (
          <Tab
            title="Integraciones"
            overrides={tabOverrides}
            key={INTEGRATIONS_SECTION}
          >
            <IntegrationsTab />
          </Tab>
        )}
        {sections.includes(NOTIFICATIONS_SECTION) && (
          <Tab
            title="Notificaciones"
            overrides={tabOverflowOverrides}
            key={NOTIFICATIONS_SECTION}
          >
            <NotificationSettingsTab />
          </Tab>
        )}
        {sections.includes(LIVE_STATUS_SECTION) && (
          <Tab
            title="Prevención de riesgos"
            overrides={tabOverflowOverrides}
            key={LIVE_STATUS_SECTION}
          >
            <LiveStatusSettingsTab />
          </Tab>
        )}
      </Tabs>
    </FullContainer>
  );
}
